import React from 'react';

const SVG = ({width = '16px', height = '16px'}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30.24 30.24"
    className="bi bi-alert"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Alert</title>
    <g fillRule="evenodd">
      <path d="M15.12,22.68a1.89,1.89,0,1,0-1.89-1.89,1.89,1.89,0,0,0,1.89,1.89Zm0-5.67A1.89,1.89,0,0,0,17,15.12V9.45a1.89,1.89,0,0,0-3.78,0v5.67A1.89,1.89,0,0,0,15.12,17Zm0,13.23A15.12,15.12,0,1,0,0,15.12,15.14,15.14,0,0,0,15.12,30.24Zm0-27.4A12.28,12.28,0,1,1,2.84,15.12,12.3,12.3,0,0,1,15.12,2.84Zm0,0"></path>
    </g>
  </svg>
);

export default SVG;
